import React from 'react';
import { Typography } from '@mui/material';
import { useAppContext } from '../../contexts/AppContext';
import ProductCard from '../../components/ProductCard/ProductCard';
import CartList from '../../components/CartList/CartList';

export default function Favorites() {
  const { favoriteItems } = useAppContext();
  return (
    <div>
      <Typography
        variant='subtitle1'
        noWrap
        sx={{ fontWeight: '600', fontSize: '1.1rem', mb: 1, mx: 2, mt: 2 }}
      >
        Favorite Items
      </Typography>
      <CartList products={favoriteItems} isFavorite />
    </div>
  );
}
